import React from 'react';
import assets, { excellence } from '../../utils/assets';
import styles from "../../pages/pages.module.scss";
import ButtonShapped from '../ButtonShapped';
import FrameCard from '../CommonCard';
import FrameCardBg from '../CommonCard';

const HowItWorksSection = () => {
  return (
    <section className="container">
      <div className={`${styles.sectionheading}`}>
        <ButtonShapped
          text="How it Works"
          type="primaryshaped"
        ></ButtonShapped>
        <h3 className="mb-4">
          <span>
            Excellence
            <img src={assets.arcblack} alt=''/>
          </span>
          in service delivery and support.
        </h3>
        <p >
          Because you didn't start your business to figure out taxes and worry
          about penalties
        </p>
      </div>

      <div className="my-3 my-md-5">
        <FrameCardBg>
          <div className={`${styles.worksnotesdiv}`}>
            <div className="row">
              <div className={`col-md-6 col-xl-5 ${styles.customcol}`}>
                <div className={styles.worksnotes}>
                  <p>
                    Access live dashboards & review transactions whenever you
                    want on the Toola platform
                  </p>
                </div>
              </div>
              <div className={`col-md col-sm col d-flex justify-content-md-end justify-content-center`} style={{ width: "50%" }}>
                <div className={styles.excellencepos}>
                  <img
                    src={assets.deliverydashboard}
                    alt=""
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </FrameCardBg>
      </div>

      <div className="row row-gap-4">
        {excellence.map((section) => (
          <div key={section.id} className="col-sm-6">
            <FrameCard>
              <div key={section.id} className={styles.exsectioncard}>
                <div>
                  <h3>{section.title}</h3>
                  <p>{section.content}</p>
                </div>
                <div className={styles.exsectioncardsubcontent}>
                  {section.subContent.map((subItem) => (
                    <div key={subItem.id} className={styles.exsubitem}>
                      <img src={subItem.icon} alt="icon" className="icon" />
                      <p>{subItem.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            </FrameCard>
          </div>
        ))}
      </div>
    </section>
  )
}

export default HowItWorksSection;